import { ConsoleLog } from './consoleLog';
const logger = new ConsoleLog();
import Moment from 'moment-timezone';

const statusLookup = {
  0:    { Name: "Disconnected", Color: 'grey', Trans: "PrinterStatus_Disconnected" },
  1:    { Name: "Connected", Color: 'blue', Trans: "PrinterStatus_Connected" },
  2:    { Name: "Online", Color: 'green',  Trans: "PrinterStatus_Online" },
  3:    { Name: "Warning", Color: 'yellow', Trans: "PrinterStatus_Warning" },
  4:    { Name: "Fault" , Color: 'red', Trans: "PrinterStatus_Fault" },
  9999: { Name: "Unknown", Color: 'white', Trans: "PrinterStatus_Unknown" },
};

export const esi = "GenericESI";
export const wsi = "GenericWSI";
export const zbc = "GenericZBC";

const VRSIdMapping = {
  1000: { make: esi, driversId: "Excel_1620_ESI", templateDesignNames: ["ESI 1620"]},
  1001: { make: zbc, driversId: "VJ1650", templateDesignNames: ["Videojet 1650"]},
  1002: { make: wsi, driversId: "WSI_1620", templateDesignNames: ["WSI 1620"] },
  1003: { make: esi, driversId: "Excel_1520_ESI", templateDesignNames: ["ESI 1520"] },
  1004: { make: wsi, driversId: "WSI_1520", templateDesignNames: ["WSI 1520"] },
  1005: { make: zbc, driversId: "VJ1550", templateDesignNames: ["Videojet 1550"] },
  1006: { make: esi, driversId: "Excel_1610", templateDesignNames: ["ESI 1610"] },
  1007: { make: wsi, driversId: "WSI_1610", templateDesignNames: ["WSI 1610"] },
  1008: { make: esi, driversId: "Excel_1510_ESI", templateDesignNames: ["ESI 1510"]},
  1009: { make: wsi, driversId: "WSI_1510", templateDesignNames: ["WSI 1510"] },
  1010: { make: esi, driversId: "Excel_1610_DH", templateDesignNames: ["ESI 1610 DH"] },
  1011: { make: wsi, driversId: "WSI_1610_DH", templateDesignNames: ["WSI 1610 DH"] },
  1012: { make: esi, driversId: "Excel_1710_ESI", templateDesignNames: ["ESI 1710"] },
  1013: { make: wsi, driversId: "WSI_1710", templateDesignNames: ["WSI 1710"] },
  1014: { make: esi, driversId: "Excel_1620_UHS", templateDesignNames: ["ESI 1620 UHS"] },
  1015: { make: wsi, driversId: "WSI_1620_UHS", templateDesignNames: ["WSI 1620 UHS"] },
  1016: { make: zbc, driversId: "VJ1650_UHS", templateDesignNames: ["Videojet 1650 UHS"] },
  1021: { make: wsi, driversId: "WSI_1530", templateDesignNames: ["WSI 1530"] },
  1022: { make: wsi, driversId: "WSI_1620_HR", templateDesignNames: ["WSI 1620 HR"] },
  1023: { make: esi, driversId: "Excel_1620_HR", templateDesignNames: ["ESI 1620 HR"] },
  1024: { make: wsi, driversId: "WSI_1630", templateDesignNames: ["WSI 1630"] },
  1032: { make: zbc, driversId: "VJ1560", templateDesignNames: ["Videojet 1560"] },
  1033: { make: zbc, driversId: "VJ1650_HR", templateDesignNames: ["Videojet 1650 HR"] },
  1034: { make: zbc, driversId: "VJ1660", templateDesignNames: ["Videojet 1660"] },
  1050: { make: zbc, driversId: "VJ1860", templateDesignNames: ["Videojet 1860"] },
  1051: { make: zbc, driversId: "VJ1860", templateDesignNames: ["Videojet 1860"] },
  1111: { make: zbc, driversId: "VJ1550", templateDesignNames: ["Videojet 1550"] },
  1121: { make: zbc, driversId: "VJ1560", templateDesignNames: ["Videojet 1560"] },
  1131: { make: zbc, driversId: "VJ1650", templateDesignNames: ["Videojet 1650"]},
  1141: { make: zbc, driversId: "VJ1650_HR", templateDesignNames: ["Videojet 1650 HR"] },
  1151: { make: zbc, driversId: "VJ1650_UHS", templateDesignNames: ["Videojet 1650 UHS"] },
  1161: { make: zbc, driversId: "VJ1660", templateDesignNames: ["Videojet 1660"] },
  1550: { make: zbc, driversId: "VJ1550", templateDesignNames: ["Videojet 1550"] },
  1560: { make: zbc, driversId: "VJ1560", templateDesignNames: ["Videojet 1560"] },
  1580: { make: zbc, driversId: "VJ1580", templateDesignNames: ["Videojet 1580"] },
  1650: { make: zbc, driversId: "VJ1650", templateDesignNames: ["Videojet 1650"]},
  1651: { make: zbc, driversId: "VJ1650_HR", templateDesignNames: ["Videojet 1650 HR"] },
  1652: { make: zbc, driversId: "VJ1650_UHS", templateDesignNames: ["Videojet 1650 UHS"] },
  1660: { make: zbc, driversId: "VJ1660", templateDesignNames: ["Videojet 1660"] },
  1710: { make: wsi, driversId: "WSI_1710", templateDesignNames: ["WSI 1710"] },
  2011: { make: zbc, driversId: "Videojet_2340", templateDesignNames: ["Videojet 2340"] },
  2021: { make: zbc, driversId: "Videojet_2350", templateDesignNames: ["Videojet 235x"] },
  2031: { make: zbc, driversId: "Videojet_2360", templateDesignNames: ["Videojet 236x"] },
  2041: { make: zbc, driversId: "Videojet_2340", templateDesignNames: ["Videojet 2340"] },
  2051: { make: zbc, driversId: "Videojet_2350", templateDesignNames: ["Videojet 235x"] },
  2061: { make: zbc, driversId: "Videojet_2350", templateDesignNames: ["Videojet 235x"] },
  2071: { make: zbc, driversId: "Videojet_2360", templateDesignNames: ["Videojet 236x"] },
  2081: { make: zbc, driversId: "Videojet_2360", templateDesignNames: ["Videojet 236x"] },
  4001: { make: zbc, driversId: "Videojet_9550", templateDesignNames: ['Videojet 9550']},
  4010: { make: zbc, driversId: "DataFlex_6320_53mm_Continuous", templateDesignNames: ["DataFlex 6320 Continuous", "DataFlex 6320 Intermittent"] }, // Continuous vs intermittent
  4011: { make: zbc, driversId: "DataFlex_6420_53mm_Continuous", templateDesignNames: ["DataFlex 6420 Continuous", "DataFlex 6420 Intermittent"] }, // size???? too???
  4050: { make: zbc, driversId: "DataFlex_6330_53mm_Continuous", templateDesignNames: ["DataFlex 6330 Continuous", "DataFlex 6330 Intermittent"] },
  4051: { make: zbc, driversId: "DataFlex_6530_53mm_Continuous", templateDesignNames: ["DataFlex 6530 Continuous", "DataFlex 6530 Intermittent"] },
  5001: { make: zbc, driversId: "Videojet_2350", templateDesignNames: ["Videojet 235x"] },
  5002: { make: zbc, driversId: "Videojet_2340", templateDesignNames: ["Videojet 2340"] },
  5003: { make: zbc, driversId: "Videojet_2350", templateDesignNames: ["Videojet 235x"] },
  5004: { make: zbc, driversId: "Videojet_2360", templateDesignNames: ["Videojet 236x"] },
  5005: { make: zbc, driversId: "Videojet_2340", templateDesignNames: ["Videojet 2340"] },
  5006: { make: zbc, driversId: "Videojet_2360", templateDesignNames: ["Videojet 236x"] },
  5007: { make: zbc, driversId: "Videojet_2350", templateDesignNames: ["Videojet 235x"] },
  5008: { make: zbc, driversId: "Videojet_2350", templateDesignNames: ["Videojet 235x"] },
  5009: { make: zbc, driversId: "Videojet_2360", templateDesignNames: ["Videojet 236x"] },
  5010: { make: zbc, driversId: "Videojet_2360", templateDesignNames: ["Videojet 236x"] },
  6021: { make: zbc, driversId: "DataFlex_6320_53mm_Continuous", templateDesignNames: ["DataFlex 6320 Continuous", "DataFlex 6320 Intermittent"] },
  6031: { make: zbc, driversId: "DataFlex_6330_53mm_Continuous", templateDesignNames: ["DataFlex 6330 Continuous", "DataFlex 6330 Intermittent"] },
  6041: { make: zbc, driversId: "DataFlex_6420_53mm_Continuous", templateDesignNames: ["DataFlex 6420 Continuous", "DataFlex 6420 Intermittent"] },
  6051: { make: zbc, driversId: "DataFlex_6530_53mm_Continuous", templateDesignNames: ["DataFlex 6530 Continuous", "DataFlex 6530 Intermittent"] },
  8011: { make: zbc, driversId: "VJ8510", templateDesignNames: ["Videojet 8510"] },
  8021: { make: zbc, driversId: "VJ8520", templateDesignNames: ["Videojet 8520"] },
  8031: { make: zbc, driversId: "VJ8610", templateDesignNames: ["Videojet 8610"] },
  8510: { make: zbc, driversId: "VJ8510", templateDesignNames: ["Videojet 8510"] },
  8520: { make: zbc, driversId: "VJ8520", templateDesignNames: ["Videojet 8520"] },
  8610: { make: zbc, driversId: "VJ8610", templateDesignNames: ["Videojet 8610"] },
  9011: { make: zbc, driversId: "Videojet_9550", templateDesignNames: ['Videojet 9550']},
};

export function getPrinterEntry(modelId) {
  let item = VRSIdMapping[modelId];
  if (item === undefined){
    item = {};
    logger.warn('%j', { fn: 'getItem', message: `No entry in VRSIdMapping for ${modelId}.` });
  }
  return item;
}

export function getTemplateDesignNames(modelId) {
  const {templateDesignNames} = getPrinterEntry(modelId);
  if (templateDesignNames === undefined) {
    logger.warn('%j', { fn: 'getTemplateDesignNames', message: `No templateDesignNames in VRSIdMapping for ${modelId}.` });
  }
  return templateDesignNames;
}

export function getPrinterStatus(printer) {
  const time = printer ? printer.lastMsgTime ? printer.lastMsgTime : printer.statusDt ? printer.statusDt : null : null;
  if (time == null || !IsWithinTime(time)) {
    return statusLookup[0];
  }
  return getStatus(printer.statusId);
}

function getStatus(statusId) {
  //Mask out the top 4 bytes so DH printers will report the status of the first head only.
  //In future we could return the status of both heads if required.
  const lowStatus = statusId & 0x0F;

  let status  = statusLookup[lowStatus];
  if (status == null) {
    logger.warn('%j', { fn: 'lookupPrinterStatus', message: `Unable to retrieve status for statusId [${statusId}].` });
    status = statusLookup[9999];
  }
  return status;
}

function IsWithinTime(time) {
  const now = Moment.utc();
  const printerTime = Moment.utc(time);

  return (printerTime.add(5, 'minutes') >= now) ? true : false;
}
